import { HttpMethods } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = 'ContentType/';

export const GetInternalContentTypesAPI = (props) => {
  const api = 'InternalTypes';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    ...props,
  });
};
